import { render, staticRenderFns } from "./screenLoading.vue?vue&type=template&id=145984c4&scoped=true"
import script from "./screenLoading.vue?vue&type=script&lang=js"
export * from "./screenLoading.vue?vue&type=script&lang=js"
import style0 from "./screenLoading.vue?vue&type=style&index=0&id=145984c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145984c4",
  null
  
)

export default component.exports